































































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  Tooltip, Button, Loading, Message,
} from 'element-ui';
import _ from 'lodash';
import { Mutation, Getter } from 'vuex-class';
import Sign from '@/servers/modules/signinsignup';

@Component({
  components: {
    Tooltip,
    Button,
  },
})
export default class extends Vue {
    ebopoOS = 'pc'
    padTap = false

    @Mutation public setScaleCommonIndex;

    @Getter public navData: any;

    @Getter public title: any;

    @Getter public userImg: any;

    @Getter public userName: any;

    @Getter public scaleCommonIndex: any;

    @Prop({ type: Boolean, default: () => false }) isShow: any ;

    // init nav active
    private defaultNavActive: any = 0;

    private navigation(item: any, index: any) {
      this.defaultNavActive = index;
      this.$router.push({ name: item.name });
    }

    private changBar() {
      this.setScaleCommonIndex(!this.scaleCommonIndex);
    }

    private created() {
      if (process.env.VUE_APP_PAD) {
        this.ebopoOS = 'pad'
      }
      // console.log(this.navData)
      const array: any = [];
      _.map(this.navData, (item: any) => {
        array.push(item.name);
      });
      this.defaultNavActive = _.indexOf(array, this.$route.name);
      if (this.$route.name == 'personal') {
        this.defaultNavActive = '#';
      }
    }

    private async dialogHandle(index:any) {
      const loading = Loading.service({ fullscreen: true, lock: true, text: '正在退出中' });
      const res = await Sign.logout().finally((e) => {
        loading.close();
        console.log(e);
      });
      if (!res.data.code) {
        Message.success('退出登录成功');
        window.LS.clear();
        this.$router.replace('/login');
      }
    }
}
